import React, { useState, useEffect, useCallback, useRef } from "react"
import { useHistory, useParams } from 'react-router-dom'
import Grid from '@material-ui/core/Grid'
import SearchIcon from '@material-ui/icons/SearchOutlined'
import Filters from '@base/Filter'
import SelectOption from '@base/Inputs/Select'
import TextField from "@base/Inputs/Text"
import Table from '@base/Table'
import Title from '@base/Title'
import Toast from '@base/Toast'
import {
	verifyPagingAndSorting,
	PAGE,
	SIZE,
	ASC,
	TOTAL_ELEMENTS,
	TOTAL_PAGES,
} from '@base/Table/Utils'

import CaixaService from "@services/CaixaService"

import { ProcessoResolver } from "@helpers/ProcessoHelper"
import { removePagingAndSorting } from '@helpers/PaginationHelper'

import { AplicarLegenda } from './Style';

import useStatusCaixa from "@hooks/enums/useStatusCaixa";

export const ListagemCaixas = () => {
	const [loading, setLoading] = useState(true);

	const listagemStatus = useStatusCaixa();

	const [list, setList] = useState([]);

	const [page, setPage] = useState(PAGE);
	const [size, setSize] = useState(SIZE);
	const [defaultOrderBy,] = useState('codigo');
	const [sort, setSort] = useState([{ orderBy: defaultOrderBy, order: ASC }])
	const [totalElements, setTotalElements] = useState(TOTAL_ELEMENTS);
	const [totalPages, setTotalPages] = useState(TOTAL_PAGES);

	const [filtros, setFiltros] = useState([]);
	const [filtroAtivo, setFiltroAtivo] = useState(false);
	const [filtroStatus, setFiltroStatus] = useState('');
	const [filtroDescricao, setFiltroDescricao] = useState('');
	const [filtroCodigoInep, setFiltroCodigoInep] = useState('');
	const [quantidadeFiltrosAplicados, setQuantidadeFiltrosAplicados] = useState(0);

	const params = useParams();
	const processo = ProcessoResolver(params.processo);

	const toastRef = useRef(null);

  	const history = useHistory();

	const pageName = 'Caixas';

	const aplicarFiltros = (ativo = false) => {
		let f = [];

		if (filtroStatus) f.push({ field: 'status', value: filtroStatus });
		if (filtroDescricao) f.push({ field: 'codigo', value: filtroDescricao });
		if (filtroCodigoInep) f.push({ field: 'codigoInep', value: filtroCodigoInep });

		setFiltros(f);
		setFiltroAtivo(ativo);
		setQuantidadeFiltrosAplicados(f.length);
	}

	const contarFiltrosAplicados = () => quantidadeFiltrosAplicados;

	const limparFiltros = () => {
		setSort([{ orderBy: defaultOrderBy, order: ASC }]);
		setPage(PAGE);
		setSize(SIZE);

		setFiltros([]);
		setFiltroAtivo(false);
		setFiltroStatus('');
		setFiltroDescricao('');
		setFiltroCodigoInep('');

		setQuantidadeFiltrosAplicados(0);
	}

	const aplicaLegendaDE = (l) => {
		if(l.conteudo === 'DIGITAL' || l.conteudo === 'IMPA') return (<></>);

		return (<AplicarLegenda params={[l.des ?? 0,l.desDigitalizados ?? 0, l.desDigitados ?? 0]} />);
	}

	const columns = [
		{ label: 'id', name: 'id', key: true, hidden: true },
		{ label: 'Código', name: 'codigo', key: false },
		{ label: 'Conteúdo', name: 'conteudo', func: (c, l) => <>
																		{c}
																		{/*} {l.qtdCartoesDigitalizadosSemEscola > 0 || l.qtdDEDigitalizadosSemEscola > 0 ?
																			<span title={l.codigoSubstituto} style={{ marginLeft:4,padding: 5, backgroundColor: "#d9746c", borderRadius: 20, color: "white" }}>Docs Intrusos</span> : ""}*/}</>, key: false },
		{ label: 'Quantidade Objetos Postais', name: 'quantidadeDeObjetosPostais', filter: 'objetosPostais', key: false, ordering: false  },
		{ label: 'Cartões', name: 'documentosDigitalizados', key: false, ordering: false  , func: (c, l) => <AplicarLegenda params={[l.cartoes ?? 0,l.cartoesDigitalizados ?? 0, l.cartoesLidosPeloOcr ?? 0, l.cartoesDigitados ?? 0]} />},
		{ label: 'DEs', name: 'documentosLidosPeloOcr', key: false, ordering: false,  func: (c, l) => aplicaLegendaDE(l)},
		{ label: 'Status', name: 'statusFormatado', filter: 'status', key: false }
	];

	const actions = [
	{
		name: () => "Visualizar Objetos Postais",
		func: (id) => redirectListagemDeObjetosPostais(id),
		icon: <SearchIcon />,
		disabled: (id, object) => object.quantidadeEscolas === 0 && object.cartoesDigitalizados === 0,
	},
	]

	const carregarDados = useCallback(() => {
		const f = verifyPagingAndSorting(removePagingAndSorting(filtros), page, size, sort, filtroAtivo);

		setLoading(true);

		CaixaService.filtrar(params.processo, f).then(resultado => {
			const { content, number, size, totalElements, totalPages } = resultado.data;
			setList(content);
			setPage(number);
			setSize(size);
			setTotalElements(totalElements);
			setTotalPages(totalPages);
			setLoading(false);

		}).catch(error => toastRef.current.show("error", "Ocorreu um Problema ao Realizar Filtros!"));
	}, [params.processo, filtros, filtroAtivo, page, size, sort]);

	const handlePage = page => { setPage(page); setFiltroAtivo(true); };

	const handleRowsPerPage = (size, page) => { setPage(page); setSize(size); setFiltroAtivo(true); };

  const verifyOrderBy = (orderBy) => orderBy === 'quantidadeDeObjetosPostais' ? 'objetosPostais'
  :  orderBy === 'statusFormatado' ? 'status': orderBy;

  const handleSort = (orderBy, order) => {
    if (sort.find(s => s.orderBy === verifyOrderBy(orderBy))) {
      let newSort = sort.filter(s => s.orderBy !== verifyOrderBy(orderBy));
      newSort.splice(sort.indexOf(sort.find(s => s.orderBy === verifyOrderBy(orderBy))), 0, {
        orderBy: verifyOrderBy(orderBy),
        order: order
      })
      setSort([...newSort]);
    } else {
      setSort([...sort.filter(s => s.orderBy !== verifyOrderBy(orderBy)), {
        orderBy: verifyOrderBy(orderBy),
        order: order
      }]);
    }
    setFiltroAtivo(true)
  }
	const handleClearSort = (orderBy) => { ; setFiltroAtivo(true); orderBy ? setSort([...sort.filter(s => s.orderBy !== orderBy)]) : setSort([{ orderBy: defaultOrderBy, order: ASC }]) };
	const handleTotalPages = () => totalPages;
	const handleTotalElements = () => totalElements;

	useEffect(() => carregarDados(), [carregarDados]);

	const redirectListagemDeObjetosPostais = (caixa) => {
		const caixaCodigo = list.find(c => c.id === caixa).codigo;
		history.push(`/${processo.id}/objetosPostais?caixa=${caixaCodigo}`);
	}

	return (
		<>
			<Toast ref={toastRef} />

			<Title>{pageName}</Title><br />

			<Filters
				handleFilter={aplicarFiltros}
				handleFilterClear={limparFiltros}
				countFilters={contarFiltrosAplicados}
			>
				<Grid item container spacing={3}>
					<Grid item sm={2} lg={2}>
						<TextField
							label='Código da Caixa'
							value={filtroDescricao}
							name='filtroDescricao'
							onChange={(e) => setFiltroDescricao(e.target.value)}
						/>
					</Grid>
					<Grid item sm={2} lg={2}>
						<TextField
							label='Codigo INEP'
							value={filtroCodigoInep}
							name='filtroCodigoInep'
							onChange={(e) => setFiltroCodigoInep(e.target.value)}
						/>
					</Grid>
					<Grid item sm={2} lg={2}>
						<SelectOption
							label='Status'
							value={filtroStatus}
							name='filtroStatus'
							onChange={(e) => setFiltroStatus(e.target.value)}
							options={listagemStatus.data}
						/>
					</Grid>
				</Grid>
			</Filters>

      <Grid container spacing={3} style={{ marginTop: '24px', merginBottom: '-6px' }}>
        <Grid item sm={12} lg={12}>
          <b>Legenda:</b>
          <AplicarLegenda params={["Total Estimado","Digitalização Concluída", "Leitura Pelo OCR Concluída", "Digitação Concluída"]} />
        </Grid>
      </Grid>

			<Table
				columns={columns}
				tableData={list}
				actions={actions}
				page={page}
				handlePage={handlePage}
				handleTotalPages={handleTotalPages}
				handleTotalElements={handleTotalElements}
				rowsPerPage={size}
				handleRowsPerPage={handleRowsPerPage}
				sort={sort}
				handleSort={handleSort}
				handleClearSort={handleClearSort}
				loading={loading}
			/>
		</>
	);
}

export default ListagemCaixas;
